<div [ngClass]="{ open: isOpen }">
  <div class="header d-flex justify-content-between">
    <div class="header-content mt-2 ml-3"><ng-content select="[header]"></ng-content></div>
    <div class="d-flex align-items-center">
      <i (click)="toggle()" [ngClass]="[isOpen ? 'rx-minus' : 'rx-add']" class="ml-3 mr-2 mt-1 pointer"></i>
    </div>
  </div>
  <div class="body" [@collapseExpandSlow]="openOrClose()">
    <div class="body-content ml-3 my-3"><ng-content select="[body]"></ng-content></div>
  </div>
</div>
